import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Job } from '../../../shared/data/models/collections/job';
import { Request } from '../../../shared/data/services/request-enum';
import { AbstractLocalizedComponent } from '../../../shared/ui/abstract.localized.component';

@Component({
  selector: 'placeme-job',
  templateUrl: './job.component.html',
  styleUrls: ['./job.component.scss'],
})
export class JobComponent extends AbstractLocalizedComponent {
  job: Job;

  constructor(private activatedRoute: ActivatedRoute) {
    super();
  }

  protected loadData(locale: string): void {
    this.collectionsService
      .query<{ jobBySlug: Job }>(Request.JOB, {
        slug: this.activatedRoute.snapshot.params.slug,
        locale,
      })
      .subscribe(data => (this.job = data.jobBySlug));
  }
}
